export default __webpack_public_path__ + "static/media/profile-default-big.2757acda.svg";